import Vue from 'vue'
import Vuex from 'vuex'
import counter from './modules/counter' // 引入加数器模块
import login from './modules/login'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex) // 安装插件

const username = sessionStorage.getItem("currentUser") ? sessionStorage.getItem("currentUser") : "";

export default new Vuex.Store({ // 实例化Vuex仓库
  modules: {
    counter,
    login
  },
  state: {
    basePath: '',
    routes: [],
    sessions: {},
    currentSession: null,
    currentUser: username,//JSON.parse(window.sessionStorage.getItem("currentUser")),
    topRole: JSON.parse(window.sessionStorage.getItem("topRole"))
  },
  mutations: {
    initRoutes(state, data) {
      state.routes = data;
    },
    INIT_CURRENTUSER(state, currentUser) {
      state.currentUser = currentUser;
    },
    INIT_TOPROLE(state, topRole) {
      state.topRole = topRole;
    },
    changeCurrentSession(state, currentSession) {
      Vue.set(state.isDot, state.currentUser.username + '#' + currentSession.username, false);
      state.currentSession = currentSession;
    }
  },
  actions: {}//,
  // plugins: [createPersistedState()]
})



// WEBPACK FOOTER //
// ./src/store/index.js